module.exports = __webpack_public_path__ + "img/xiaomi-2.b6858ffd.png";